import { useState, useEffect } from "react";
import { Carousel } from "flowbite-react";

import { useDispatch, useSelector } from "react-redux";
import { fetchMovies } from "../stores/actions/movieAction";
import Swal from "sweetalert2";
import CardImage from "../components/CardImage";
import { fetchGenres } from "../stores/actions/genreAction";

function HomePage() {
  const dispatch = useDispatch();
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(false);
  const { movies } = useSelector((state) => state.movies);
  const { genres } = useSelector((state) => state.genres);
  const [displayedMovies, setDisplayedMovies] = useState([]);
  const [number, setNumber] = useState(4);
  const [filter, setFilter] = useState("All");

  const loadMore = () => {
    showLoading();
    setNumber(number + 4);
  };
  useEffect(() => {
    if (movies.length) {
      setDisplayedMovies(movies.filter((el, idx) => idx < number));
    }
  }, [movies]);

  useEffect(() => {
    setDisplayedMovies(movies.filter((el, idx) => idx < number));
  }, [number]);

  useEffect(() => {
    dispatch(fetchMovies())
      .then(() => {
        return dispatch(fetchGenres());
      })
      .then(() => {
        setLoading(false);
      })
      .catch((err) => {
        setError(true);
        Swal.fire({
          icon: "error",
          title: "Oops...",
          text: err.message,
        });
      });
  }, []);

  useEffect(() => {
    dispatch(fetchGenres())
      .then(() => {
        setLoading(false);
      })
      .catch((err) => {
        setError(true);
        Swal.fire({
          icon: "error",
          title: "Oops...",
          text: err.message,
        });
      });
  }, []);

  function showLoading() {
    Swal.fire({
      title: "Loading",
      timer: 1200,
      didOpen: () => {
        Swal.showLoading();
      },
    });
  }

  const changeInput = (e) => {
    const { value } = e.target;
    if (value === "All") {
      setFilter("All");
      setDisplayedMovies(movies.filter((el, idx) => idx < number));
      showLoading();
    } else {
      const filteredMovies = movies.filter((el) => el.Genre.name === value);
      setDisplayedMovies(filteredMovies);
      setFilter(value);
      showLoading();
    }
  };
  return (
    <>
      /{loading && showLoading()}
      {!loading && (
        <div className="mb-1">
          <div className="h-carous2 mx-4 my-2 mt-10 border-none">
            <Carousel>
              <img
                src="https://cdn0-production-images-kly.akamaized.net/PN4DOZL96HHmgOFvIjq8ZpidvNM=/1200x1200/smart/filters:quality(75):strip_icc():format(jpeg)/kly-media-production/medias/3938072/original/005855900_1645152662-Pengabdi_Setan_2.jpeg"
                alt="..."
              />
              <img
                src="https://www.gamespot.com/a/uploads/screen_kubrick/1578/15789737/3515433-endgamedek.jpg"
                alt="..."
              />
              <img
                src="https://movietalkexpress.files.wordpress.com/2014/10/furious-7.jpg"
                alt="..."
              />
              <img
                src="https://cdn.kibrispdr.org/data/741/movie-poster-landscape-0.jpg"
                alt="..."
              />
              <img
                src="https://www.coffeeandcigarettes.co.uk/wp-content/uploads/2017/08/LandOfMine_CCWebsite_1600x900-1.jpg"
                alt="..."
              />
            </Carousel>
          </div>
          <h2 className="mt-4 text-2xl font-semibold text-biru">
            Select Category
          </h2>
          <form>
            <select
              name="genreId"
              value={filter}
              onChange={changeInput}
              className="rounded-lg w-3/12 p-3 mt-2 text-biru focus:outline-biru focus:shadow-inner"
            >
              <option value="All">All</option>
              {genres.rows.map((el) => (
                <option key={el.id + "genre"} value={el.name}>
                  {el.name}
                </option>
              ))}
            </select>
          </form>
          {!displayedMovies.length && (
            <p className="mt-4 mb-4 text-2xl font-semibold text-biru">
              Sorry we can't find any movies for this category
            </p>
          )}
          <div className="grid place-items-center grid-cols-4 mt-6">
            {displayedMovies.map((movie) => (
              <CardImage movie={movie} key={movie.id + "movie"} />
            ))}
          </div>
        </div>
      )}
      {movies.length !== displayedMovies.length && filter === "All" && (
        <div className="mb-6 mx-auto rounded h-10 mt-8 bg-zinc-500 w-40 flex justify-center items-center">
          <button
            onClick={() => loadMore()}
            type="submit"
            className="h-full rounded w-40 font-bold tracking-widest text-biru uppercase bg-biru-coral shadow-lg focus:outline-none hover:bg-biru-coral hover:opacity-80"
          >
            Load More
          </button>
        </div>
      )}
    </>
  );
}

export default HomePage;
